import React, { Component } from 'react';
import { Link } from 'react-router-dom';
//components
import Language from "../languageComponent/language";
//graphics
import PageBack from "../../Assets/Images/pageBack.png";
//site images
import SiteImage0 from "../../Assets/Images/home/ministryHistory/0.jpg";
import SiteImage1 from "../../Assets/Images/home/ministryHistory/1.jpg";
import SiteImage2 from "../../Assets/Images/home/ministryHistory/2.jpg";
import SiteImage3 from "../../Assets/Images/home/ministryHistory/3.jpg";
import SiteImage4 from "../../Assets/Images/home/ministryHistory/4.jpg";
import SiteImage5 from "../../Assets/Images/home/ministryHistory/5.jpg";
import SiteImage6 from "../../Assets/Images/home/ministryHistory/6.jpg";
import SiteImage7 from "../../Assets/Images/home/ministryHistory/7.jpg";
import SiteImage8 from "../../Assets/Images/home/ministryHistory/8.jpg";
import SiteImage9 from "../../Assets/Images/home/ministryHistory/9.jpg";
import SiteImage10 from "../../Assets/Images/home/ministryHistory/10.jpg";
import SiteImage11 from "../../Assets/Images/home/ministryHistory/11.jpg";
//ongoing
import SerojaCycloneFundEnglish from "../../Assets/Images/ourMinistries/Ongoing/serojaCycloneEng.jpg";
import SerojaCycloneFundChinese from "../../Assets/Images/ourMinistries/Ongoing/serojaCycloneChi.jpg";
import IndiaCovid19FundEnglish from "../../Assets/Images/ourMinistries/Ongoing/indiaCovid19Eng.jpg";
import IndiaCovid19FundChinese from "../../Assets/Images/ourMinistries/Ongoing/indiaCovid19Chi.jpg";
import ChristmasGiftDonationEnglish from "../../Assets/Images/ourMinistries/Ongoing/christmasGiftDonationEng.jpg";
import ChristmasGiftDonationChinese from "../../Assets/Images/ourMinistries/Ongoing/christmasGiftDonationChi.jpg";
import BantuanBanjirFundraisingEnglish from "../../Assets/Images/ourMinistries/Ongoing/bantuanBanjirFundraisingEng.jpg";
import BantuanBanjirFundraisingChinese from "../../Assets/Images/ourMinistries/Ongoing/bantuanBanjirFundraisingChi.jpg";
//mvs
import MVAPoster from "../../Assets/Images/home/mvaPoster.jpg";
//ministry reports
import Covid19Malaysia1 from "../../Assets/Images/ourMinistries/Covid19/malaysia1.jpg";
import Covid19Malaysia2 from "../../Assets/Images/ourMinistries/Covid19/malaysia2.jpg";

const SiteImage = [SiteImage0, SiteImage1, SiteImage2, SiteImage3, SiteImage4, SiteImage5, SiteImage6, SiteImage7, SiteImage8, SiteImage9, SiteImage10, SiteImage11];
const navCovid19MinistryPos = {landscape: 4073, portrait: 5907};
const navSlideShowPosLand = {0:0 ,1:0 ,2:6110, 3:3671, 4:2151, 5:1004, 6:3280, 7:1471, 8:2392, 9:1825, 10:3000, 11:713};
const navSlideShowPosPort = {0:0 ,1:0 ,2:7703, 3:4973, 4:2700, 5:1420, 6:4540, 7:1871, 8:3460, 9:2384, 10:4072, 11:974};//weird case, cant scroll to 2700 and 3400
//size variable classname
const mvaPosterClass = {landscape: "poster-landscape", portrait: "poster-portrait"};
const reportPosterClass = {landscape: "poster-landscape", portrait: "poster-portrait"};
class Home extends Component {
    constructor(props) {
      super(props);
      this.state = { siteDimensions: {}, screenDimensions: {}, imageCount: 0};
      this.onSiteImageLoad = this.onSiteImageLoad.bind(this);
      this.swapImages = this.swapImages.bind(this);
      setInterval(this.swapImages, 2000);
    }
    render() {
      return(
        <div className="container-fluid">
            <div className="background-image"><img onLoad={this.onImageLoad} style={{
                width: "100%", height: '100%'
            }} src={PageBack} /></div>
            <div className="site-image" onClick={()=>this.onNavigateToSection(this.props.orientation == "landscape" ? navSlideShowPosLand[this.state.imageCount] : navSlideShowPosPort[this.state.imageCount])}>
                <Link to="/Ministries">
                    <img onLoad={this.onSiteImageLoad} style={{ position: "absolute", left: (this.state.screenDimensions.width / 2) - (this.state.siteDimensions.width / 2), width: this.state.siteDimensions.width_height_ratio * document.getElementsByClassName("site-image").offSetHeight, height: "100%" }} src={SiteImage[this.state.imageCount]} />
                </Link>
            </div>
            <div className="bible-verse" style={{fontSize: '2vh' ,lineHeight: '3vh'}}><Language language={this.props.language} section="bibleVerse"/></div>
            <div className="site-content">
                <div className="separator"></div>
                <div className="line-separator"/>
                {/*Ongoin */}
                <div className="ongoing-ministries">
                    <p className="ongoing-title"><Language language={this.props.language} section="ongoingTitle"/></p>
                    <div className="poster-panel" onClick={()=>this.onNavigateToSection(0)}><Link to="/Ministries">
                        {/*<div className="poster-box">
                            <img style={{width: "40vh", margin:"2vw"}} src={this.props.language=="eng" ? ChristmasGiftDonationEnglish:ChristmasGiftDonationChinese} />
        </div> ---deprecated*/}
                        <div className="poster-box">
                            <img style={{width: "40vh", margin:"2vw"}} src={this.props.language=="eng" ? BantuanBanjirFundraisingEnglish:BantuanBanjirFundraisingChinese} />
                        </div>
                    </Link></div>
                </div>
                <div className="line-separator"/>
                {/*MVA */}
                <div className="methodist-volunteer-academy">
                    <p style={{ position: 'relative', width: '100%', textAlign: 'left', fontSize: '6vh', lineHeight: '6.5vh', fontWeight: 'bold' }}><Language language={this.props.language} section="mvaTitle" /></p>
                    <div style={{position:'relative'}}>
                        <img className={mvaPosterClass[this.props.orientation]} src={MVAPoster} alt="MVAPoster"/>
                        <button className="mva-join-button" onClick={()=>{window.location.href="https://docs.google.com/forms/d/e/1FAIpQLSdzz_qoKZvkxqipRZoLR6uPPD_zQQq6Qp4613Cnhtj7zUAejQ/viewform?fbclid=IwAR0sIfkoU7zkMGzaoGGi76n90-qvksYMbjJ6fXc4CTcpfRzrCB-UUBFunkA"}}><Language language={this.props.language} section="joinMVAButton"/></button>
                    </div>
                </div>
                <div className="line-separator"/>
                {/*Report */}
                <div className="ministries-report">
                    <p style={{ position: 'relative', width: '100%', textAlign: 'left', fontSize: '6vh', lineHeight: '6.5vh', fontWeight: 'bold' }}><Language language={this.props.language} section="reportTitle" /></p>
                    <div style={{zIndex: 5}} onClick={()=>this.onNavigateToSection(navCovid19MinistryPos[this.props.orientation])}><Link to="/Ministries">
                        <img className={reportPosterClass[this.props.orientation]} src={Covid19Malaysia1} alt="Covid19Malaysia1"/>
                        <img className={reportPosterClass[this.props.orientation]} src={Covid19Malaysia2} alt="Covid19Malaysia2"/>
                    </Link></div>
                </div>
                <div className="separator"></div>
                <div className="line-separator"/>
            </div>
        </div>
    );}
    swapImages = (e) => {
    this.setState({
        imageCount: this.state.imageCount < 11 ? this.state.imageCount + 1 : 0,
    });
    }
    onSiteImageLoad({ target: source }) {
    this.setState({
        siteDimensions: {
        height: source.height,
        width: source.width,
        width_height_ratio: source.width / source.height
        }
    });
    }
    resize() {
        this.setState({
          screenDimensions: {
            height: window.innerHeight,
            width: window.innerWidth
          }
        });
      }
    componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    }
    onNavigateToSection = (e) => {
        this.props.updateScrollPos(e);
      }
} export default Home;